import {BaseModel} from "../base-model";
import {observable, computed, makeObservable} from 'mobx';
import { action } from "mobx"

export const ANIMATION = {
  LIFE_CYCLE: {
    waiting: 'waiting',
    animating: 'animating',
    ended: 'ended',
  }
};

export class BaseAnimation extends BaseModel {
  enterAnimationClassName: String;
  mainAnimationClassName: String;
  leaveAnimationClassName: String;
  noAnimationClassName: String;
  mainDurationMS: Number;
  enterDurationMS: Number;
  leaveDurationMS: Number;
  delayMS: Number;
  @observable _currentClassName: String;
  @observable state: ANIMATION.LIFE_CYCLE;

  constructor(
    enterAnimationClassName: String = "",
    mainAnimationClassName: String = "",
    leaveAnimationClassName: String = "",
    noAnimationClassName: String = '',
    mainDurationMS: Number = 0,
    enterDurationMS: Number = 0,
    leaveDurationMS: Number = 0,
    delayMS: Number = 0
  ) {
    super();

    this.enterAnimationClassName = enterAnimationClassName;
    this.mainAnimationClassName = mainAnimationClassName;
    this.leaveAnimationClassName = leaveAnimationClassName;
    this.noAnimationClassName = noAnimationClassName;
    this.mainDurationMS = mainDurationMS;
    this.enterDurationMS = enterDurationMS;
    this.leaveDurationMS = leaveDurationMS;
    this.delayMS = delayMS;
    this._currentClassName = this.noAnimationClassName;
    this.state = ANIMATION.LIFE_CYCLE.waiting;

    makeObservable(this);
  }

  @action start() {
    this.state = ANIMATION.LIFE_CYCLE.animating;
    this.enter();
  }

  enter() {
    this.currentAnimationClassName = this.enterAnimationClassName;
  }

  main() {
    this.currentAnimationClassName = this.mainAnimationClassName;
  }

  leave() {
    this.currentAnimationClassName = this.leaveAnimationClassName;
  }

  @action stop() {
    this.currentAnimationClassName = this.noAnimationClassName;
    this.state = ANIMATION.LIFE_CYCLE.ended;
  }

  set currentAnimationClassName(className: String) {
    this._currentClassName = className;
  }

  @computed get currentAnimationClassName(): String {
    return this._currentClassName;
  }
}
